// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BehanceSquareFilledSvg from "@ant-design/icons-svg/es/asn/BehanceSquareFilled";
import AntdIcon from '../components/AntdIcon';

var BehanceSquareFilled = function BehanceSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BehanceSquareFilledSvg
  }));
};

BehanceSquareFilled.displayName = 'BehanceSquareFilled';
export default React.forwardRef(BehanceSquareFilled);